<template>
  <div>
    <div id="fullpage">
      <!-- 第一页 -->
      <div class="section section1">
        <div class="page1">
          <div class="content">
            <div class="text_box animated-content">
              <img class="about_nineton_img" src="@/assets/img/culture_nineton.png" />
              <h1 class="head_name">九吨生活</h1>
              <!-- <p class="en_title">Ninetone news</p> -->
              <div class="icon_origin"></div>
            </div>
            <div class="img_box animated-content">
              <div class="img_list">
                <img :src="lifeList[0].resource" class="list" />
                <img :src="lifeList[1].resource" class="list2" />
              </div>
              <div class="img_list2">
                <img :src="lifeList[2].resource" class="list3" />
                <img :src="lifeList[3].resource" class="list4" />
              </div>
              <div class="img_list3">
                <img :src="lifeList[4].resource" class="list5" />
                <img :src="lifeList[5].resource" class="list6" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二页 -->
      <div class="section section2">
        <div class="page2">
          <div class="content">
            <div class="text_box animated-content">
              <img class="about_nineton_img" src="@/assets/img/culture_nineton.png" />
              <h1 class="head_name">九吨新闻</h1>
              <!-- <p class="en_title">Ninetone news</p> -->
              <div class="icon_origin"></div>
              <div class="page">
                <div class="img_btn">
                  <img v-show="page !== 1" src="@/assets/img/back_btn.png" @click="backPage" style="cursor: pointer" />
                </div>
                <div class="btns">
                  <span class="page_btn">{{ page }}</span> /
                  <span>{{ totle }}</span>
                </div>
                <div class="img_btn">
                  <img v-show="page !== totle && totle != 1" src="@/assets/img/go_btn.png" @click="goPage"
                    style="cursor: pointer" />
                </div>
              </div>
            </div>
            <div class="img_box animated-content">
              <Vuehorizontaltimeline :srcList="srcList" :items="cultureList" :mouseFlag="true"
                class="time_box" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="xiahua" v-if="nowIndex != 1">
      <p v-if="someData == '1' && page_name == 'index'">
        <img @click="changeIndex" src="@/assets/img/xiahua.svg" />
      </p>
      <p v-else>
        <img @click="changeIndex" src="@/assets/img/xiahua_00.svg" />
      </p>
    </div>
  </div>
</template>

<script>
import fullpage from "fullpage.js";
// import { swiper.css, SwiperSlide } from 'vue-awesome-swiper'
import Vuehorizontaltimeline from "@/components/Timeline.vue";
import { mapGetters, mapActions } from "vuex";
import "swiper/css/swiper.css";
import Swiper from "swiper";
export default {
  components: {
    Vuehorizontaltimeline,
  },
  data() {
    return {
      fillpage: null,
      page: 1,
      totle: 5,
      cultureList: [
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的“春天”",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的“春天”",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的“春天”",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的“春天”",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
      ],
      lifeList: [
        { resource: "" },
        { resource: "" },
        { resource: "" },
        { resource: "" },
        { resource: "" },
        { resource: "" },
      ],
      nowIndex: null,
      timer: null,
      srcList: [], //大图预览
    };
  },
  mounted() {
    this.updateSomeData("1");
    this.scrollContainer = document.getElementById("scrollBox");
    this.scrollPosition = 0;
    this.animationFrameId = null;
    // 获取生活信息
    this.getLife();
    // 公司新闻接口
    this.getNews();
    this.initSwiper();
    this.initFullPage();
    this.fillpage.moveTo(this.$route.query.page ? this.$route.query.page : 1);
  },
  computed: {
    ...mapGetters(["someData"]),
    ...mapGetters(["page_name"]),
  },
  // 销毁fullpage
  beforeDestroy() {
    if (this.fillpage) {
      this.fillpage.destroy("all");
    }
    /*     clearInterval(this.timer);
    this.timer = null; */
  },
  methods: {
    ...mapActions(["updateSomeData"]),
    ...mapActions(["updatePageName"]),
    initFullPage() {
      let _this = this;
      this.fillpage = new fullpage("#fullpage", {
        // sectionsColor: ['#f0f0f0', '#4BBFC3', '#7BAABE', 'whitesmoke', '#000'],
        // navigationTooltips: ['Section 1', 'Section 2', 'Section 3', 'Section 4', 'Section 5'],
        // anchors: ['section1', 'section2', 'section3', 'section4', 'section5'],
        // menu: '#menu',
        afterLoad: function (origin, destination, direction) {
          _this.nowIndex = destination.index;
          /* if (origin.item.querySelector(".animated-content")) {
            origin.item
              .querySelector(".animated-content")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-left")) {
            origin.item
              .querySelector(".animated-content-left")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-top")) {
            origin.item
              .querySelector(".animated-content-top")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-rigth")) {
            origin.item
              .querySelector(".animated-content-rigth")
              .classList.remove("active");
          } */
          // 找出加载的 section 中所有可能的动画元素
          /* let animatedElements = destination.item.querySelectorAll(
            ".animated-content, .animated-content-left, .animated-content-top, .animated-content-rigth"
          );

          // 为每个元素添加动画类
          animatedElements.forEach((element) => {
            element.classList.add("active");
          }); */
          if (destination.index == 1) {
            /* _this.timer = setInterval(() => {
              if (_this.page + 1 > _this.totle) {
                _this.page = 1;
                const scrollBox = document.getElementById("scrollBox");
                const scrollDistance = scrollBox.clientWidth * _this.totle;
                scrollBox.scrollBy({
                  left: -scrollDistance,
                  behavior: "smooth",
                });
                this.page -= 1;
              } else {
                _this.page += 1;
                const scrollBox = document.getElementById("scrollBox");
                const scrollDistance = scrollBox.clientWidth;
                scrollBox.scrollBy({
                  left: scrollDistance,
                  behavior: "smooth",
                });
              }
            }, 5000); */
            /*             const scrollWidth = _this.scrollContainer.scrollWidth;
            const containerWidth = _this.scrollContainer.clientWidth;
            if (scrollWidth > containerWidth) {
              const endPosition = scrollWidth - containerWidth;
              const increment = 1;

              const animate = () => {
                _this.scrollPosition += increment;
                if (_this.scrollPosition > endPosition) {
                  _this.scrollPosition = 0; // 将滚动位置重置为0
                }
                _this.scrollContainer.scrollLeft = _this.scrollPosition;
                if (_this.scrollPosition < endPosition) {
                  _this.animationFrameId = requestAnimationFrame(animate);
                } else {
                  _this.scrollPosition = 0; // 将滚动位置重置为0并继续滚动
                  _this.animationFrameId = requestAnimationFrame(animate);
                }
              };

              _this.animationFrameId = requestAnimationFrame(animate);
            } else {
              _this.scrollPosition = 0;
            } */
          }
        },
        onLeave: function (origin, destination, direction) {
          // 如果离开的 section 包含动画内容，移除动画类
          /* if (origin.item.querySelector(".animated-content")) {
            origin.item
              .querySelector(".animated-content")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-left")) {
            origin.item
              .querySelector(".animated-content-left")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-top")) {
            origin.item
              .querySelector(".animated-content-top")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-rigth")) {
            origin.item
              .querySelector(".animated-content-rigth")
              .classList.remove("active");
          } */
          /* let animatedElements = origin.item.querySelectorAll(
            ".animated-content, .animated-content-left, .animated-content-top, .animated-content-rigth"
          );
          // 为每个元素移除动画类
          animatedElements.forEach((element) => {
            element.classList.remove("active");
          }); */
          /* if (destination.index == 1) {
            clearInterval(_this.timer);
            _this.timer = null;
          } */
        },
        // 其他fullpage配置项...
      });
    },
    initSwiper() {
      new Swiper(".swiper", {
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
    // 后退
    backPage() {
      const scrollBox = document.getElementById("scrollBox");
      const scrollDistance = scrollBox.clientWidth;
      scrollBox.scrollBy({ left: -scrollDistance, behavior: "smooth" });
      this.page -= 1;
    },
    // 翻页
    goPage() {
      const scrollBox = document.getElementById("scrollBox");
      const scrollDistance = scrollBox.clientWidth;
      scrollBox.scrollBy({ left: scrollDistance, behavior: "smooth" });
      this.page += 1;
    },
    // 插件路由
    navigateToSection(sectionIndex) {
      this.fillpage.moveTo(sectionIndex);
    },
    // 获取公司生活信息
    async getLife() {
      const [err, res] = await this.$http.get("life");
      if (err) {
        return;
      }
      this.lifeList = res.list;
    },
    // 获取公司新闻
    async getNews() {
      const [err, res] = await this.$http.get("news");
      if (err) {
        return;
      }
      this.cultureList = res.list;
      this.srcList = res.list.map((item) => {
        return item.extends.big_pic;
      });
      this.totle = Math.ceil(res.list.length / 2.8);
    },
    changeIndex() {
      this.fillpage.moveSectionDown();
    },
  },
  watch: {
    $route: {
      handler: function (val) {
        this.fillpage
          ? this.fillpage.moveTo(
            this.$route.query.page ? this.$route.query.page : 1
          )
          : "";
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/css/base.less";

.png18 {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.section1 {
  position: relative;

  .page1 {
    position: relative;
    height: 100vh;
    // width: 1580px;
    margin: 0 200px;

    .content {
      position: relative;
      .media1();
      padding: 200px 0px 0 0px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;

      .text_box {
        position: relative;
        height: 557px;
        width: 279px;
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        width: 877px;
        // height: 680px;
        display: flex;
        justify-content: space-between;

        .img_list {
          width: 262px;
          text-align: right;
        }

        .img_list2 {
          padding-top: 42px;
          width: 262px;
        }

        .img_list3 {
          margin-top: -62px;
          width: 262px;
        }

        .list {
          width: 146px;
          height: 174px;
          margin-bottom: 57px;
        }

        .list2 {
          width: 262px;
          height: 312px;
        }

        .list3 {
          width: 262px;
          height: 312px;
          margin-bottom: 53px;
        }

        .list4 {
          width: 262px;
          height: 312px;
        }

        .list5 {
          width: 262px;
          height: 312px;
          margin-bottom: 53px;
        }

        .list6 {
          width: 262px;
          height: 312px;
        }
      }
    }
  }
}

.section2 {
  position: relative;

  .page2 {
    position: relative;
    height: 100vh;
    margin: 0 200px;
    // width: 1580px;

    .content {
      position: relative;
      padding: 200px 0px 0 0px;
      .media1();
      display: flex;
      justify-content: space-between;

      .text_box {
        position: relative;
        height: 557px;
        width: 279px;
        z-index: 999999;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;

          img {
            width: 70px;
            height: 70px;
          }

          .img_btn {
            width: 70px;
            height: 70px;
          }

          .btns {
            font-size: 14px;
            color: #000000;

            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        width: 1258px;
      }
    }
  }
}

.xiahua {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999999;

  img {
    cursor: pointer;
  }
}</style>
